import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

export default function Faq({ items, chapterN = 9, dark = true, title, idPrefix = 'faq' }) {
  const t = useT();
  const { HOME_FAQS } = useContent();
  const faqs = items || HOME_FAQS;
  const heading = title || t['fq.h2'];

  return (
    <section data-testid={`${idPrefix}-section`} className={`py-24 md:py-32 ${dark ? 'bg-ink text-white' : 'bg-white text-ink'}`}>
      <div className="container-site grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Chapter n={chapterN} label={t['ch.faq']} dark={!dark} />
          <FadeUp>
            <h2 className="font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">{heading}</h2>
            <p className={`mt-5 max-w-sm text-base leading-relaxed ${dark ? 'text-silver' : 'text-neutral-500'}`}>{t['fq.p']}</p>
          </FadeUp>
        </div>
        <div className="lg:col-span-7">
          <FadeUp delay={0.1}>
            <Accordion type="single" collapsible data-testid={`${idPrefix}-accordion`}>
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className={dark ? 'border-white/10' : 'border-black/10'}>
                  <AccordionTrigger data-testid={`${idPrefix}-question-${i}`}
                    className={`text-left text-base font-semibold hover:text-gold hover:no-underline ${dark ? 'text-white' : 'text-ink'}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent data-testid={`${idPrefix}-answer-${i}`} className={`text-sm leading-relaxed ${dark ? 'text-silver' : 'text-neutral-600'}`}>
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
